import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { viewSchemas } from "@redotech/redo-views-common/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const saveReturnView = {
  name: "saveReturnView" as const,
  input: z.object({
    view: viewSchemas.returns,
    type: createEnum(ReturnTypeEnum),
  }),
  output: z.object({}),
};
